import { disableBodyScroll, enableBodyScroll } from '@cell/cell-core/body-scroll-lock';
import Component from '@cell/cell-core/component/component';
import Swiper from 'swiper';
import { Navigation, Pagination, Thumbs, Zoom } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/zoom';
import './zoom-modal.scss';

class ZoomModal extends Component {
  constructor() {
    super();

    this.elements = {
      galleryImages: this.querySelectorAll('.ZoomModal__Main .swiper-slide .Image'),
    };

    this.thumbnailsSwiper = new Swiper(this.querySelector('.ZoomModal__Thumbnails.swiper'), {
      direction: 'vertical',
      navigation: {
        prevEl: '.ZoomModal__Thumbnails .swiper-button-prev',
        nextEl: '.ZoomModal__Thumbnails .swiper-button-next',
      },
      slidesPerView: 'auto',
      spaceBetween: 16,
    });

    this.mainSwiper = new Swiper(this.querySelector('.ZoomModal__Main.swiper'), {
      modules: [Navigation, Pagination, Thumbs, Zoom],
      navigation: {
        prevEl:
          '.ZoomModal__BulletNavigation .swiper-button-prev, .ZoomModal__NavigationButton--Prev',
        nextEl:
          '.ZoomModal__BulletNavigation .swiper-button-next, .ZoomModal__NavigationButton--Next',
      },
      pagination: {
        el: '.ZoomModal__BulletNavigation .swiper-pagination',
        bulletClass: 'swiper-pagination-bullet',
        bulletElement: 'button',
      },
      zoom: {
        containerClass: 'swiper-zoom-container',
        maxRatio: 2,
      },
      thumbs: {
        swiper: this.thumbnailsSwiper,
      },
      observer: true,
      on: {
        observerUpdate: () => {
          this.updateCSSVariables();
        },
        slideChange: () => {
          if (this.zoomedIn) {
            this.mainSwiper.zoom.out();
            this.zoomedIn = false;
          }
        },
      },
      breakpoints: {
        1024: {
          zoom: {
            toggle: false,
          },
        },
      },
    });

    this.zoomedIn = false;

    this.handleOpen = this.handleOpen.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.handleCloseButtonClick = this.handleCloseButtonClick.bind(this);
  }

  componentDidMount() {
    this.on('c-button.click.close', this.handleCloseButtonClick);

    this.elements.galleryImages.forEach((image) => {
      // For mobile we use the native double-tap zoom of swiper.
      if (window.innerWidth < 1024) return;

      image.on('click', () => {
        if (!this.zoomedIn) {
          this.mainSwiper.zoom.in();
          this.zoomedIn = true;
        }
      });
    });

    globalThis.on('product-gallery.open-zoom-modal', this.handleOpen);
    globalThis.on('resize', this.handleResize);
  }

  handleOpen(event) {
    // Check if the closest `ProductMain` element of the event target is the same as the closest
    // `ProductMain` of this component. If not, return.
    // This ensures that the event is coming from the product gallery of the current step.
    if (event.target.closest('.ProductMain') !== this.closest('.ProductMain')) return;

    const clickedImageIndex = event.data.index;

    this.mainSwiper.slideTo(clickedImageIndex);
    this.thumbnailsSwiper.slideTo(clickedImageIndex);

    this.open();
  }

  handleResize() {
    this.updateCSSVariables();
  }

  handleCloseButtonClick() {
    this.close();
  }

  open() {
    disableBodyScroll();

    this.classList.add('ZoomModal--Active');

    this.updateCSSVariables();
  }

  close() {
    enableBodyScroll();

    this.mainSwiper.zoom.out();
    this.zoomedIn = false;

    this.classList.remove('ZoomModal--Active');
  }

  updateCSSVariables() {
    const activeImage = this.querySelector('.ZoomModal__Main .swiper-slide-active img');

    if (!activeImage) return;

    const { left, right } = activeImage.getBoundingClientRect();

    this.style.setProperty('--main-image-left', `${left}px`);
    this.style.setProperty('--main-image-right', `${right}px`);
  }
}

customElements.define('zoom-modal', ZoomModal);
